import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { Reveal } from './Reveal';
import { ConfettiRain } from './ConfettiRain';
import { included } from '../data/content';
const tints = ['#FDEAEC', '#E6F2FB', '#E9F6EE', '#FFF7E4'];
export function WhatsIncluded() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-cream py-11 sm:py-14" aria-labelledby="included-title" data-id="element-266" data-mp="pvnr6ouenp33">
      <ConfettiRain count={12} opacity={0.4} data-id="element-267" data-mp="utfpq1pk29g9" />

      <div className="relative mx-auto max-w-content px-5 sm:px-8" data-id="element-268" data-mp="us4p2arephtd">
        <Reveal data-id="element-269" data-mp="gu7ol39u0r9f">
          <h2 id="included-title" className="mx-auto max-w-2xl text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-270" data-mp="gwtwj40mx8s6">
            Un año entero de ideas en{' '}
            <span className="text-sky" data-id="element-271" data-mp="36kkvm5ai2zxx">un solo lugar</span>
          </h2>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-272" data-mp="1whfbdly09uab">
          {included.map((b, i) => <Reveal as="article" key={b.title} delay={i * 0.06} data-id="element-273" data-mp="1rjnmz1wkkqav" data-mpi={i}>
              <div className="h-full rounded-3xl p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
            backgroundColor: tints[i % tints.length],
            borderTop: `5px solid ${b.accent}`
          }} data-id="element-274" data-mp="26fv2hox193jt">
                <motion.span className="inline-flex text-3xl" aria-hidden="true" animate={reduce ? undefined : {
              y: [0, -7, 0],
              rotate: [-4, 4, -4]
            }} transition={{
              duration: 4 + i % 3,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.3
            }} data-id="element-275" data-mp="2afdpqrcbtqpt">
                  {b.emoji}
                </motion.span>
                <h3 className="mt-3 font-display text-base font-extrabold uppercase" style={{
              color: b.accent
            }} data-id="element-276" data-mp="31agrwjqwyp9r">
                  {b.title}
                </h3>
                <p className="mt-2 font-sans text-sm leading-relaxed text-muted" data-id="element-277" data-mp="3b4yypxrmn0xs">
                  {b.description}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}